<template>
  <div class="rank">
    <!-- 本月排行榜（个人） -->
    <div class="rank-box">
      <top :title="title"></top>
      <div class="rank-con">
        <scroller
          lock-x
          scrollbar-y
          use-pullup
          v-if="totalCount"
          class="rank-scroller"
          :pullup-config="pullConfig"
          @on-pullup-loading="loadMore"
        >
          <div class="rank-box-item">
            <card
              v-for="(item, index) in renderData"
              :key="item.appraiser_id"
              class="rank-card">
              <div
                :class="['rank-card__box', { first: index === 0, second: index === 1, third: index === 2 }]"
                slot="header">
                <p class='rank-number'>No.{{ index + 1 }}</p>
                <img class="rank-avatar" :src="item.avatar">
              </div>
              <div slot="content" class="rank-card__content">
                <p class="rank-name">{{ item.name }}</p>
                <div class="rank-count">
                  <p class="rank-count__left" :class="{ highlight: queryForm.type === 1 }">
                    <span class="rank-count__left__wid">线索</span> {{ item.new_tickets }}
                  </p>
                  <p class="rank-count__right">
                    <span class="rank-count__right__wid">本品线索</span> {{ item.new_tickets_own }}
                  </p>
                  <p class="rank-count__left" :class="{ highlight: queryForm.type === 2 }">
                    <span class="rank-count__left__wid">评估</span> {{ item.evaluated_tickets }}
                  </p>
                  <p class="rank-count__right">
                    <span class="rank-count__right__wid">本品评估</span> {{ item.evaluated_tickets_own }}
                  </p>
                  <p class="rank-count__left">
                    <span class="rank-count__left__wid">收车</span> {{ item.inbound_cars }}
                  </p>
                  <p class="rank-count__right">
                    <span class="rank-count__right__wid">本品收车</span> {{ item.inbound_cars_own }}
                  </p>
                </div>
                <p class="rank-store">{{ item.store }}</p>
              </div>
            </card>
            <p class="rank-tip">共{{ totalNumber }}位评估师参与排名</p>
          </div>
        </scroller>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import { Card, Scroller } from '@lx-frontend/cvux'
import Top from './components/Top'
export default {
  components: { Top, Card, Scroller },
  data() {
    return {
      title: '',
      queryForm: {
        type: 1,
        page: 1,
        count: 10
      },
      pullConfig: {
        content: '',
        downContent: '',
        upContent: '',
        loadingContent: '加载中...'
      },
      renderData: [],
      totalCount: 0
    }
  },
  async created() {
    this.queryForm.type = ~~this.$route.query.type
    const categoty = this.queryForm.type === 1 ? '线索' : '评估'
    this.title = `本月${categoty}排行榜（个人）`
    await this.getPersonalRankList(this.queryForm)
    this.renderData = [...this.personalRankList]
  },
  methods: {
    ...mapActions('rank', ['getPersonalRankList']),
    async loadMore(done) {
      if (this.queryForm.page * this.queryForm.count < this.totalNumber) {
        ++this.queryForm.page
        await this.getPersonalRankList(this.queryForm)
        this.renderData = [...this.renderData, ...this.personalRankList]
        done(100)
      } else {
        done()
      }
    }
  },
  computed: {
    ...mapState('rank', ['personalRankList', 'totalNumber'])
  },
  filters: {
    toPercent(num) {
      return Math.round(num * 100) + '%'
    }
  },
  watch: {
    renderData(val) {
      this.totalCount = val.length
    }
  }
}

</script>
<style lang="less" scoped>
@import "../../../stylesheets/base/fn.less";
.rank {
  background: #889aae;
  height: 100%;
  padding-top: 14/@w;

  &-box{
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    width: 356/@w;
    height: 98%;
    overflow: hidden;
    margin: 0 auto;

    .rank-con{
      flex: 1;
      width: 340/@w;
      height: 100%;
      margin: auto;
      background: #fff;

      .rank-box-item{
        width: 340/@w;
        padding: 15/@w;
        margin-bottom: 1000/@w;
        box-sizing: border-box;

        .rank-card{
          display: flex;
          flex: row nowrap;
          padding: 14/@w 0;
          border-bottom: 1px solid #f8f8f8;

          &:before{
            border: none;
          }

          &:after{
            border: none;
          }

          &__box{
            position: relative;
            margin-left: 26/@w;

            .rank-number{
              position: absolute;
              top: 46/@w;
              display: block;
              width: 100%;
              height: 15/@w;
              line-height: 15/@w;
              text-align: center;
              font-family: PingFangSC-Semibold;
              font-size: 12/@w;
              color: #ffffff;
              z-index: 2;
            }

            .rank-avatar{
              display: block;
              width: 60/@w;
              height: 60/@w;
              border-radius: 50%;
            }

            &:before{
              position: absolute;
              display: block;
              top: -12/@w;
              right: -5/@w;
              content: "";
              width: 25/@w;
              height: 22/@w;
            }

            &:after{
              position: absolute;
              display: block;
              top: 42/@w;
              right: -10/@w;
              content: "";
              width: 76/@w;
              height: 18/@w;
              background: url('../../../stylesheets/images/rank/bottom.png') no-repeat 0 0 / cover;
            }

          }

          .first{
            &:before{
              background: url('../../../stylesheets/images/rank/first-top.png') no-repeat 0 0 / cover;
            }

            &:after{
              background: url('../../../stylesheets/images/rank/first-bottom.png') no-repeat 0 0 / cover;
            }
          }

          .second{
            &:before{
              background: url('../../../stylesheets/images/rank/second-top.png') no-repeat 0 0 / cover;
            }

            &:after{
              background: url('../../../stylesheets/images/rank/second-bottom.png') no-repeat 0 0 / cover;
            }
          }

          .third{
            &:before{
              background: url('../../../stylesheets/images/rank/third-top.png') no-repeat 0 0 / cover;
            }

            &:after{
              background: url('../../../stylesheets/images/rank/third-bottom.png') no-repeat 0 0 / cover;
            }
          }

          &__content{
            width: 200/@w;
            margin-left: 27/@w;

            .rank-name{
              font-family: PingFangSC-Semibold;
              font-size: 16/@w;
              color: #333333;
              overflow:hidden;
              text-overflow:ellipsis;
              white-space:nowrap;
            }

            .rank-count{
              font-size: 13/@w;
              display: flex;
              flex-direction: row;
              flex-wrap: wrap;
              width: 200/@w;
              margin: 5/@w 0;

              &__left{
                height: 20/@w;
                line-height: 20/@w;
                width: 80/@w;
                flex: none;

                &__wid{
                  display: inline-block;
                  width: 28/@w;
                }
              }

              &__right{
                height: 20/@w;
                line-height: 20/@w;
                color: #333333;
                width: 120/@w;
                flex: none;

                &__wid{
                  display: inline-block;
                  width: 56/@w;
                }
              }

              .highlight{
                color: #09b6f8;
              }
            }

            .rank-store{
              font-family: PingFangSC-Regular;
              font-size: 13/@w;
              color: #999999;
              overflow:hidden;
              text-overflow:ellipsis;
              white-space:nowrap;
            }

            .rank-rate{
              height: 30/@w;
              line-height: 30/@w;
              font-size: 13/@w;
              color: #09b6f8;
            }
          }
        }

        .rank-tip{
          height: 40/@w;
          line-height: 40/@w;
          padding-bottom: 24/@w;
          text-align: center;
          font-size: 15/@w;
          color: #999;
        }
      }
    }
  }
}
</style>
